import { DisplayCity } from '@sales-app/types/DisplayCity'
import { gql } from 'graphql-request'

export namespace DisplayCitiesQueries {
  export namespace GET_DISPLAY_CITIES {
    export type Response = { displayCities: DisplayCity[] | null }
  }

  export function getDisplayCities() {
    return gql`
      query getDisplayCities($filter: DisplayCityFilter) {
        displayCities(filter: $filter) {
          name
          slug
          id
          regionAbbreviation
        }
      }
    `
  }
  export function getDisplayCity() {
    return gql`
      query getDisplayCity($displayCityId: Int!) {
        displayCity(id: $displayCityId) {
          name
          slug
          id
          regionAbbreviation
        }
      }
    `
  }
}
